import React, { createContext, useCallback, useContext, useMemo, useState } from "react";
import { toast } from "sonner";

const NewsletterContext = createContext(null);

export function NewsletterProvider({ children }) {
  const [email, setEmail] = useState("");
  const [regUpdates, setRegUpdates] = useState(true);
  const [busy, setBusy] = useState(false);

  const submit = useCallback(
    async (e) => {
      e?.preventDefault?.();
      if (!email.trim()) {
        toast.error("Enter your email.");
        return;
      }
      setBusy(true);
      try {
        const r = await fetch("/api/forms/newsletter", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            email: email.trim(),
            regulation_updates: regUpdates,
            _gotcha: "",
          }),
        });
        if (!r.ok) {
          const detail = await r
            .json()
            .then((j) => (typeof j?.detail === "string" ? j.detail : "Subscribe failed"))
            .catch(() => "Subscribe failed");
          throw new Error(detail);
        }
        toast.success("Subscribed!");
        setEmail("");
        setRegUpdates(true);
      } catch (err) {
        console.error("Newsletter submit", err);
        toast.error(err?.message || "Subscribe failed.");
      }
      setBusy(false);
    },
    [email, regUpdates]
  );

  const value = useMemo(
    () => ({
      email,
      setEmail,
      regUpdates,
      setRegUpdates,
      busy,
      submit,
    }),
    [email, regUpdates, busy, submit]
  );

  return <NewsletterContext.Provider value={value}>{children}</NewsletterContext.Provider>;
}

export function useNewsletter() {
  const v = useContext(NewsletterContext);
  if (!v) throw new Error("useNewsletter must be used within NewsletterProvider");
  return v;
}
